import { motion } from "motion/react";
import { Award, Building2, Users2 } from "lucide-react";

export function TrustBuilders() {
  const certifications = [
    {
      icon: Award,
      title: "80G Tax Exemption",
      description: "Registered under Section 80G",
    },
    {
      icon: Building2,
      title: "Verified NGO",
      description: "GuideStar India certified",
    },
    {
      icon: Users2,
      title: "UNWTO SDGS Aligned",
      description: "Goals 8, 10, and 12",
    },
  ];

  // const partners = [
  //   { name: "Immerse India Tours", logo: "IIT" },
  //   { name: "Immersive Trips", logo: "IT" },
  //   { name: "GuideStar India", logo: "GI" },
  //   { name: "UNWTO", logo: "UN" },
  // ];

  return (
    <section className="py-32 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Certifications */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-20"
        >
          <h2 className="text-3xl md:text-4xl text-center mb-12">
            Trusted & Certified
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {certifications.map((cert, index) => (
              <motion.div
                key={cert.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
                  <cert.icon className="text-primary" size={28} />
                </div>
                <h3 className="text-lg font-semibold mb-2">{cert.title}</h3>
                <p className="text-sm text-muted-foreground">
                  {cert.description}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Partners */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h3 className="text-lg text-muted-foreground mb-8">
            Associated With
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-12">
            {partners.map((partner, index) => (
              <motion.div
                key={partner.name}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group"
              >
                <div className="w-24 h-24 rounded-full bg-white border-2 border-border flex items-center justify-center group-hover:border-primary transition-colors">
                  <span className="text-lg font-bold text-muted-foreground group-hover:text-primary transition-colors">
                    {partner.logo}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground mt-2">
                  {partner.name}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div> */}
      </div>
    </section>
  );
}
